import { ArrowRight, Download, Github, Linkedin, Mail, MapPin } from 'lucide-react'
import { motion } from 'framer-motion'
import { profile } from '../data/profile'

const Hero = () => {
  return (
    <section id="hero" className="section-shell grid min-h-[calc(100vh-5rem)] items-center gap-12 py-20 lg:grid-cols-[1.2fr_0.8fr] lg:py-24">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        <span className="inline-flex rounded-full border border-academic-line bg-white px-4 py-2 text-sm font-semibold text-academic-blue">
          Portfolio
        </span>
        <h1 className="mt-8 max-w-5xl text-4xl font-semibold tracking-tight text-academic-text md:text-6xl lg:text-7xl">
          {profile.headline}
        </h1>
        <p className="mt-7 max-w-2xl text-lg leading-8 text-academic-muted md:text-xl">
          {profile.summary}
        </p>
        <div className="mt-10 flex flex-col gap-3 sm:flex-row">
          <a href="#projects" className="primary-button">
            View Projects <ArrowRight className="ml-2" size={17} />
          </a>
          <a href={profile.resumeUrl} className="secondary-button" download>
            Download Resume <Download className="ml-2" size={17} />
          </a>
          <a href="#contact" className="secondary-button">
            Contact Me <Mail className="ml-2" size={17} />
          </a>
        </div>
      </motion.div>

      <motion.aside
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.15, ease: 'easeOut' }}
        className="card p-6 shadow-soft md:p-8"
        aria-label="Applicant profile"
      >
        <div className="rounded-2xl bg-academic-soft p-5">
          <p className="text-sm font-semibold text-academic-blue">Applicant Profile</p>
          <h2 className="mt-3 text-2xl font-semibold text-academic-text">{profile.name}</h2>
          <p className="mt-2 text-sm leading-6 text-academic-muted">{profile.role}</p>
        </div>

        <dl className="mt-6 grid gap-4 text-sm">
          <div className="flex items-start justify-between gap-4 border-b border-academic-line pb-4">
            <dt className="text-academic-muted">Focus</dt>
            <dd className="max-w-[13rem] text-right font-medium text-academic-text">AI, Full-stack, HCI</dd>
          </div>
          <div className="flex items-start justify-between gap-4 border-b border-academic-line pb-4">
            <dt className="text-academic-muted">Current goal</dt>
            <dd className="max-w-[13rem] text-right font-medium text-academic-text">Master&apos;s in Computer Science</dd>
          </div>
          <div className="flex items-center justify-between gap-4 border-b border-academic-line pb-4">
            <dt className="text-academic-muted">Location</dt>
            <dd className="inline-flex items-center gap-2 font-medium text-academic-text">
              <MapPin size={16} /> {profile.location}
            </dd>
          </div>
        </dl>

        <div className="mt-6 flex gap-3">
          <a aria-label="GitHub" href={profile.github} className="secondary-button flex-1 px-4">
            <Github size={18} />
          </a>
          <a aria-label="LinkedIn" href={profile.linkedin} className="secondary-button flex-1 px-4">
            <Linkedin size={18} />
          </a>
          <a aria-label="Email" href={`mailto:${profile.email}`} className="secondary-button flex-1 px-4">
            <Mail size={18} />
          </a>
        </div>
      </motion.aside>
    </section>
  )
}

export default Hero
